import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import * as Sentry from '@sentry/browser'

// Components

// JS
import { login, getUserDetails, getUserProfileSettings } from '../../js/rest.js'
import { handleFetchError } from '../../js/sentry'
import { BACKEND_ENVIRONMENT } from '../../js/constants'
import { saveAuth } from '../../api/authStorage'
import ErrorMessage from '../../components/errormessage/ErrorMessage'
import { setAuth } from '../login/actions'
import teqplayLogo from '../../images/teqplay-logo-white.png'

// CSS
import './Login.scss'

class Login extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      username: '',
      password: '',
      error: null,
      loggingIn: false
    }
  }

  render() {
    const app = BACKEND_ENVIRONMENT === 'development' ? 'TERMINALPLANNERDEV' : 'TERMINALPLANNER'

    return (
      <div className="loading-login-wrapper">
        <div className="login-container">
          <div className="login-inner">
            <span className="login-title">Terminal Planner</span>
            {this.state.error && <ErrorMessage message={this.state.error} />}
            <form className="login-form" onSubmit={this.handleLogin}>
              <input
                className="textfield"
                placeholder="Username"
                type="text"
                value={this.state.username}
                onChange={this.usernameChangedHandler}
                disabled={this.state.loggingIn}
              />
              <input
                className="textfield"
                placeholder="Password"
                type="password"
                value={this.state.password}
                onChange={this.passwordChangedHandler}
                disabled={this.state.loggingIn}
              />
              <input
                className="login-btn"
                type="submit"
                value={this.state.loggingIn ? 'Logging in...' : 'Login'}
                disabled={this.state.loggingIn}
              />
            </form>

            <a
              className="forgot-password"
              href={`https://account.teqplay.nl/forgot?app=${app}${
                app === 'TERMINALPLANNERDEV' ? '&developer=true' : ''
              }`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Forgot password?
            </a>
          </div>
          <a href="http://teqplay.nl/" target="_blank" rel="noopener noreferrer" className="teqplay-logo">
            <img src={teqplayLogo} alt="teqplay" />
          </a>
        </div>
      </div>
    )
  }

  usernameChangedHandler = e => this.setState({ username: e.target.value })

  passwordChangedHandler = e => this.setState({ password: e.target.value })

  //Handle login form submission
  handleLogin = async e => {
    e.preventDefault()

    // Reset the error state
    this.setState({ error: null, loggingIn: true })

    try {
      const loginDetails = await login({ username: this.state.username, password: this.state.password })

      if (loginDetails.token === undefined) {
        this.setState({ error: 'Unable to login' })
        return
      }

      const userDetails = await getUserDetails(loginDetails.token)
      const userSettings = await getUserProfileSettings(loginDetails.token)

      const username = userDetails._id
      const terminalId = userDetails.currentTerminal.id
      const userRoles = userDetails.currentTerminal.roles

      const userTerminals = userDetails.terminals

      // Set user to Sentry
      Sentry.configureScope(scope => {
        scope.setUser({
          username,
          roles: userRoles,
          terminalId
        })
      })

      if (!terminalId) {
        this.setState({ error: 'No Terminal found for user' })
        return
      }

      // Save tokens and basic identity in localStorage for the new API client
      saveAuth({
        username: this.state.username,
        token: loginDetails.token,
        refreshToken: loginDetails.refreshToken,
        terminalId
      })

      this.props.dispatch(
        setAuth(
          this.state.username,
          loginDetails.token,
          loginDetails.refreshToken,
          userRoles,
          terminalId,
          userTerminals,
          userSettings
        )
      )
      this.props.history.push('/')
    } catch (err) {
      let message
      console.error(err)

      if (err.status === 401) {
        // login failed
        message = 'Login failed: username or password are incorrect'
      } else {
        message = err.message
        handleFetchError(err)
      }

      this.setState({ error: message })
    } finally {
      this.setState({ loggingIn: false })
    }
  }
}

export default connect(state => state)(Login)
